import { createRouter, createWebHistory } from "vue-router";
import CalicoBadge from "@/pages/calico/badge/index.vue";
import CalicoBanner from "@/pages/calico/banner/index.vue";
import CalicoButtonPage from "@/pages/calico/button/index.vue";
import CalicoCard from "@/pages/calico/card/index.vue";
import CalicoCheckbox from "@/pages/calico/checkbox/index.vue";
import CalicoContainedIcon from "@/pages/calico/containedIcon/index.vue";
import CalicoDatePicker from "@/pages/calico/datepicker/index.vue";
import CalicoDropdown from "@/pages/dropdown/index.vue";
import CalicoField from "@/pages/calico/field/index.vue";
import CalicoFileDropzone from "@/pages/calico/fileDropzone/index.vue";
import CalicoFileItem from "@/pages/calico/fileItem/index.vue";
import CalicoForm from "@/pages/pattern/form/index.vue";
import CalicoFormHeaderPage from "@/pages/calico/formHeader/index.vue";
import CalicoListItemPage from "@/pages/calico/listitem/index.vue";
import CalicoMenuItem from "@/pages/calico/menuItem/index.vue";
import CalicoNavbar from "@/pages/calico/navbar/index.vue";
import CalicoNavigationTab from "@/pages/calico/navigationtab/index.vue";
import TemplateOnboarding from "@/pages/template/onboarding/index.vue";
import CalicoProgressBar from "@/pages/pattern/progressBar/index.vue";
import CalicoProgressBarStep from "@/pages/calico/progressBarStep/index.vue";
import CalicoRadioButton from "@/pages/calico/radiobutton/index.vue";
import CalicoChip from "@/pages/calico/chip/index.vue";
import RepresentativePersonalDetails from "@/pages/kyc/representative/personalDetails/index.vue";
import RepresentativePersonalContact from "@/pages/kyc/representative/personalContact/index.vue";
// BSBLD-971: Temporarily removed from SMB onboarding — will be re-enabled in a future release
//import RepresentativeVerifyIdentity from "@/pages/kyc/representative/verifyIdentity/index.vue";
//import RepresentativeDemographic from "@/pages/kyc/representative/demographic/index.vue";
import CalicoSearch from "@/pages/calico/search/index.vue";
import CalicoSelectCard from "@/pages/calico/selectCard/index.vue";
import CalicoStatusCard from "@/pages/calico/statusCard/index.vue";
import CalicoDrawer from "@/pages/calico/drawer/index.vue";
import CalicoUploadFile from "@/pages/pattern/uploadFile/index.vue";
import VerifyEmail from "@/pages/verify/index.vue";
import ExpiredVerificationLink from "@/pages/verificationExpired/index.vue";
import ChooseAccount from "@/pages/chooseAccount/index.vue";
import SearchResults from "@/pages/searchResults/index.vue";
import CalicoBusinessCard from "@/pages/calico/businessCard/index.vue";
import CalicoIconCard from "@/pages/calico/iconCard/index.vue";
import TemplateDashboard from "@/pages/template/dashboard/index.vue";
import WidgetTip from "@/pages/widget/tip/index.vue";
import WidgetSearch from "@/pages/widget/search/index.vue";
import CalicoBusinessSmallCard from "@/pages/calico/businessSmallCard/index.vue";
import Representative from "@/pages/representative/index.vue";
import CalicoScoreMeter from "@/pages/pattern/scoreMeter/index.vue";
import CalicoConfirmation from "@/pages/pattern/confirmation/index.vue";
import CalicoLoanBeaconIndicator from "@/pages/calico/loanBeaconIndicator/index.vue";
import Login from "@/pages/login/index.vue";
import ForgotPassword from "@/pages/forgotPassword/index.vue";
import {
  authenticated,
  hasAccessCode,
  isOwner,
  isRepresentative,
  notAccessCode,
  notAuthenticated,
  notVerified,
  onboarded,
  oobCode,
  verified,
  notResetPasswordCodeVerified,
  hasResetPasswordCodeVerified,
  authorizeBusinessAccess,
  notOnboarded
} from "@/middleware/auth";
import SignUp from "@/pages/signup/index.vue";
import CalicoTopFactor from "@/pages/calico/topFactor/index.vue";
import WidgetBetaScore from "@/pages/widget/betascore/index.vue";
import CalicoStoryCard from "@/pages/calico/storyCard/index.vue";
import WidgetSummary from "@/pages/widget/summary/index.vue";
import Business from "@/pages/business/index.vue";
import financials from "@/pages/business/financials/index.vue";
import CalicoBusinessInfo from "@/pages/calico/businessInfo/index.vue";
import CalicoLoader from "@/pages/calico/loader/index.vue";
import CalicoFont from "@/pages/calico/font/index.vue";
import CalicoSelectedBusiness from "@/pages/pattern/selectedBusiness/index.vue";
import CalicoNavbarMenuItem from "@/pages/calico/navbarMenuItem/index.vue";
import CalicoNavbarMenu from "@/pages/calico/navbarMenu/index.vue";
import CalicoGlobalNavigation from "@/pages/pattern/globalNavigation/index.vue";
import TemplateLogin from "@/pages/template/login/index.vue";
import ClaimBusinessScreen from "@/pages/kyc/businessOwner/claimBusiness/index.vue";
import VerifyOwnership from "@/pages/kyc/businessOwner/verifyOwnership/index.vue";
import WebAndSocials from "@/pages/kyc/businessOwner/webAndSocials/index.vue";
import EntityDetails from "@/pages/kyc/businessOwner/entityDetails/index.vue";
import CalicoMeter from "@/pages/calico/meter/index.vue";
import CalicoAIContent from "@/pages/calico/aiContent/index.vue";
import CalicoPromptBubble from "@/pages/calico/promptBubble/index.vue";
import CalicoResult from "@/pages/pattern/result/index.vue";
import CalicoPromptResult from "@/pages/pattern/promptResult/index.vue";
import CalicoHistory from "@/pages/calico/history/index.vue";
import CalicoAIReply from "@/pages/calico/aiReply/index.vue";
import CalicoCloseChat from "@/pages/calico/closeChat/index.vue";
import CalicoChatInputField from "@/pages/calico/chatInputField/index.vue";
import CalicoAiResponseLoader from "@/pages/calico/aiResponseLoader/index.vue";
import WidgetConversations from "@/pages/widget/conversations/index.vue";
import Modal from "@/pages/template/modal/index.vue";
import CalicoFileCard from "@/pages/calico/fileCard/index.vue";
import CalicoCreditBoxScale from "@/pages/calico/creditBoxScale/index.vue";
import CalicoCreditBox from "@/pages/pattern/creditBox/index.vue";
import CalicoTooltip from "@/pages/calico/tooltip/index.vue";
import CalicoSearchDialog from "@/pages/pattern/dialog/index.vue";
import AccessCode from "@/pages/kyc/representative/accessCode/index.vue";
import ResetPassword from "@/pages/resetPassword/index.vue";
import ExpiredResetPasswordLink from "@/pages/expiredResetPasswordLink/index.vue";
import WidgetFinancials from "@/pages/widget/financials/index.vue";
import CalicoPaginationPage from "@/pages/calico/pagination/index.vue"
import MultiStepModal from "@/pages/template/multiStepModal/index.vue";
import CalicoTiersTableDialog from "@/pages/pattern/tiersTableDialog/index.vue";
import CalicoUnderstandBetascoreDialog from "@/pages/pattern/understandBetascoreDialog/index.vue";
import CalicoUsageDialog from "@/pages/pattern/usageDialog/index.vue";
import CalicoUsageViewProfileConfirmationDialog from "@/pages/pattern/usageViewProfileConfirmation/index.vue";
import CalicoDeepSearchBannerPage from "@/pages/pattern/deepSearchBanner";
import CalicoToggle from "@/pages/calico/toggle/index.vue";
import WidgetBetaScoreTracker from "@/pages/widget/betascoreTracker/index.vue";
import WidgetLoanBeacon from "@/pages/widget/loanBeacon/index.vue";
import WidgetBusinessAttributes from "@/pages/widget/businessAttributes/index.vue";
import CalicoCardInfo from "@/pages/calico/cardInfo/index.vue";
import CalicoSubscriptionCard from "@/pages/calico/subscriptionCard/index.vue";
import CalicoBillingItem from "@/pages/calico/billingItem/index.vue";
import CalicoDocumentListItem from "@/pages/calico/documentListItem/index.vue";
import CalicoDocumentUploadInline from "@/pages/calico/documentUploadInline/index.vue";
import Settings from "@/pages/settings/index.vue";
import ManageSubscription from "@/pages/settings/billing/manageSubscription/index.vue";
import Payment from "@/pages/kyc/businessOwner/payment/index.vue";
import CalicoFinancialDocuments from "@/pages/pattern/financialDocuments/index.vue";
import { hasActiveSubscription, notActiveSubscription } from "@/middleware/auth";
import CalicoLoanProfile from '@/pages/pattern/loanProfile/index.vue';
import CalicoDocumentItem from "@/pages/pattern/documentItem/index.vue";
import CalicoDocumentSection from "@/pages/pattern/documentSection/index.vue";

const routes = [
  {
    path: "/",
    name: "*",
    component: Login,
    beforeEnter: [notAuthenticated],
  },
  {
    path: "/forgot-password",
    name: "Forgot Password",
    component: ForgotPassword,
    beforeEnter: [notAuthenticated],
  },
  {
  path: "/auth/action",
  name: "AuthAction",
  component: () => import("@/pages/auth/ActionHandler.vue"),
  },
  {
    path: "/expired-reset-password-link",
    name: "Expired Reset Password Link",
    component: ExpiredResetPasswordLink,
    beforeEnter: [notAuthenticated, notResetPasswordCodeVerified],
  },
  {
    path: "/reset-password",
    name: "Reset Password",
    component: ResetPassword,
    beforeEnter: [notAuthenticated, hasResetPasswordCodeVerified],
  },
  {
    path: "/calico",
    name: "Calico",
    children: [
      {
        path: "badge",
        name: "Calico Badge",
        component: CalicoBadge,
      },
      {
        path: "dropdown",
        name: "Dropdown",
        component: CalicoDropdown,
      },
      {
        path: "button",
        name: "Calico Button",
        component: CalicoButtonPage,
      },
      {
        path: "search",
        name: "Calico Search",
        component: CalicoSearch,
      },
      {
        path: "field",
        name: "Calico Field",
        component: CalicoField,
      },
      {
        path: "progress-bar-step",
        name: "Calico ProgressBarStep",
        component: CalicoProgressBarStep,
      },
      {
        path: "header",
        name: "Calico Header",
        component: CalicoFormHeaderPage,
      },
      {
        path: "checkbox",
        name: "Calico Checkbox",
        component: CalicoCheckbox,
      },
      {
        path: "listitem",
        name: "Calico List Item",
        component: CalicoListItemPage,
      },
      {
        path: "file-item",
        name: "Calico FileItem",
        component: CalicoFileItem,
      },
      {
        path: "navbar",
        name: "Calico Navbar",
        component: CalicoNavbar,
      },
      {
        path: "file-dropzone",
        name: "Calico FileDropzone",
        component: CalicoFileDropzone,
      },
      {
        path: "navigationTab",
        name: "Calico Navigation Tab",
        component: CalicoNavigationTab,
      },
      {
        path: "datePicker",
        name: "Calico Date Picker",
        component: CalicoDatePicker,
      },
      {
        path: "selectCard",
        name: "Calico Select Card",
        component: CalicoSelectCard,
      },
      {
        path: "statusCard",
        name: "Calico Status Card",
        component: CalicoStatusCard,
      },
      {
        path: "card",
        name: "Calico Card",
        component: CalicoCard,
      },
      {
        path: "contained-icon",
        name: "Calico Contained Icon",
        component: CalicoContainedIcon,
      },
      {
        path: "banner",
        name: "Calico Banner",
        component: CalicoBanner,
      },
      {
        path: "radioButton",
        name: "Calico RadioButton",
        component: CalicoRadioButton,
      },
      {
        path: "icon-card",
        name: "Icon Card",
        component: CalicoIconCard,
      },
      {
        path: "chip",
        name: "Calico Chip",
        component: CalicoChip,
      },
      {
        path: "drawer",
        name: "Calico Drawer",
        component: CalicoDrawer,
      },
      {
        path: "business-card",
        name: "Calico Business Card ",
        component: CalicoBusinessCard,
      },
      {
        path: "business-small-card",
        name: "Calico Small Business Card ",
        component: CalicoBusinessSmallCard,
      },
      {
        path: "top-factor",
        name: "Calico Top Factor",
        component: CalicoTopFactor,
      },
      {
        path: "story-card",
        name: "Calico Story Card ",
        component: CalicoStoryCard,
      },
      {
        path: "business-info",
        name: "Calico Business Info",
        component: CalicoBusinessInfo,
      },
      {
        path: "loader",
        name: "Calico Loader",
        component: CalicoLoader,
      },
      {
        path: "font",
        name: "Font",
        component: CalicoFont,
      },
      {
        path: "menu-item",
        name: "Calico Menu Item",
        component: CalicoMenuItem,
      },
      {
        path: "navbar-menu-item",
        name: "Calico Navbar Menu Item",
        component: CalicoNavbarMenuItem,
      },
      {
        path: "navbar-menu",
        name: "Calico Navbar Menu",
        component: CalicoNavbarMenu,
      },
      {
        path: "meter",
        name: "Calico Meter",
        component: CalicoMeter,
      },
      {
        path: "ai-content",
        name: "Calico AI Content",
        component: CalicoAIContent,
      },
      {
        path: "prompt-bubble",
        name: "Prompt Bubble",
        component: CalicoPromptBubble,
      },
      {
        path: "ai-reply",
        name: "AI Reply",
        component: CalicoAIReply,
      },
      {
        path: "close-chat",
        name: "Close Chat",
        component: CalicoCloseChat,
      },
      {
        path: "chat-input-field",
        name: "Calico Chat Input Field",
        component: CalicoChatInputField,
      },
      {
        path: "prompt-bubble",
        name: "Prompt Bubble",
        component: CalicoPromptBubble,
      },
      {
        path: "ai-content",
        name: "Calico AI Content",
        component: CalicoAIContent,
      },
      {
        path: "ai-reply",
        name: "AI Reply",
        component: CalicoAIReply,
      },
      {
        path: "history",
        name: "Calico History",
        component: CalicoHistory,
      },
      {
        path: "ai-response-loader",
        name: "Calico AI Response Loader",
        component: CalicoAiResponseLoader,
      },
      {
        path: "file-card",
        name: "Calico File Card",
        component: CalicoFileCard,
      },
      {
        path: "credit-box-scale",
        name: "Calico CreditBoxScale",
        component: CalicoCreditBoxScale,
      },
      {
        path: "tooltip",
        name: "Calico Tooltip",
        component: CalicoTooltip,
      },
      {
        path: "pagination",
        name: "Calico Pagination",
        component: CalicoPaginationPage,
      },
      {
        path: "toggle",
        name: "Calico Toggle",
        component: CalicoToggle,
      },
      {
        path: "card-info",
        name: "Calico Card Info",
        component: CalicoCardInfo,
      },
      {
        path: "subscription-card",
        name: "Calico Subscription Card",
        component: CalicoSubscriptionCard,
      },
      {
        path: "billing-item",
        name: "Calico Billing Item",
        component: CalicoBillingItem,
      },
      {
        path: "document-list-item",
        name: "Calico Document List Item",
        component: CalicoDocumentListItem,
      },
      {
        path: "document-upload-inline",
        name: "Calico Document Upload Inline",
        component: CalicoDocumentUploadInline,
      },
      {
        path: "loan-beacon-indicator",
        name: "Calico Funding Passport Indicator",
        component: CalicoLoanBeaconIndicator,
      },
    ],
  },
  {
    path: "/widget",
    name: "Widgets",
    children: [
      {
        path: "betascore",
        name: "Calico BetaScore ",
        component: WidgetBetaScore,
      },
      {
        path: "summary",
        name: "Widget Summary ",
        component: WidgetSummary,
      },
      {
        path: "tip",
        name: "Widget Tip ",
        component: WidgetTip,
      },
      {
        path: "search",
        name: "Calico Search ",
        component: WidgetSearch,
      },
      {
        path: "conversations",
        name: "Calico Conversations ",
        component: WidgetConversations,
      },
      {
        path: "financials",
        name: "Calico Financials ",
        component: WidgetFinancials,
      },
      {
        path: "betascore-tracker",
        name: "Calico BetaScore Tracker",
        component: WidgetBetaScoreTracker,
        beforeEnter: [authenticated, verified, onboarded],
      },
      {
        path: "loan-beacon/:id",
        name: "Calico Funding Passport™",
        component: WidgetLoanBeacon,
        beforeEnter: [authenticated, verified, onboarded],
      },
      {
        path: "loan-beacon",
        name: "Widget Calico Loan Beacon",
        component: WidgetLoanBeacon,
        beforeEnter: [authenticated, verified, onboarded],
      },
      {
        path: "business-attributes",
        name: "Calico Business Attributes",
        component: WidgetBusinessAttributes,
        beforeEnter: [authenticated, verified, onboarded],
      },
    ],
  },
  {
    path: "/pattern",
    name: "Pattern",
    children: [
      {
        path: "progress-bar",
        name: "Calico ProgressBar",
        component: CalicoProgressBar,
      },
      {
        path: "form",
        name: "Calico Form",
        component: CalicoForm,
      },
      {
        path: "search-dialog",
        name: "Calico Search Dialog",
        component: CalicoSearchDialog,
      },
      {
        path: "deep-search-banner",
        name: "Calico Deep Search Banner",
        component: CalicoDeepSearchBannerPage,
      },
      {
        path: "upload-file",
        name: "Calico Upload File",
        component: CalicoUploadFile,
      },
      {
        path: "selected-business",
        name: "Calico Selected Business",
        component: CalicoSelectedBusiness,
      },
      {
        path: "global-navigation",
        name: "Calico Global Navigation",
        component: CalicoGlobalNavigation,
      },
      {
        path: "score-meter",
        name: "Calico Score Meter ",
        component: CalicoScoreMeter,
      },
      {
        path: "result",
        name: "AI Result",
        component: CalicoResult,
      },
      {
        path: "prompt-result",
        name: "Calico Prompt Result",
        component: CalicoPromptResult,
      },
      {
        path: "credit-box",
        name: "Calico CreditBox",
        component: CalicoCreditBox,
      },
      {
        path: "tiers-table-dialog",
        name: "Calico Tiers Table Dialog",
        component: CalicoTiersTableDialog,
      },
      {
        path: "understand-betascore-dialog",
        name: "Calico Understand BetaScore Dialog",
        component: CalicoUnderstandBetascoreDialog,
      },
      {
        path: "usage-dialog",
        name: "Calico Usage Dialog",
        component: CalicoUsageDialog,
      },
      {
        path: "usage-view-profile-confirmation",
        name: "Calico Usage View Profile Confirmation",
        component: CalicoUsageViewProfileConfirmationDialog,
      },
      {
        path: "confirmation",
        name: "Calico Confirmation",
        component: CalicoConfirmation,
      },
      {
        path: "financial-documents",
        name: "Calico Financial Documents",
        component: CalicoFinancialDocuments,
      },
      {
        path: "loan-profile",
        name: "Calico Loan Profile",
        component: CalicoLoanProfile,
      },
      {
        path: "document-item",
        name: "Calico Document Item",
        component: CalicoDocumentItem
      },
      {
        path: "document-section",
        name: "Calico Document Section",
        component: CalicoDocumentSection
      }
    ],
  },
  {
    path: "/template",
    name: "Template",
    children: [
      {
        path: "onboarding",
        name: "Template Onboarding",
        component: TemplateOnboarding,
      },
      {
        path: "dashboard",
        name: "Template Dashboard",
        component: TemplateDashboard,
      },
      {
        path: "login",
        name: "Template Login",
        component: TemplateLogin,
      },
      {
        path: "modal",
        name: "Template Modal",
        component: Modal,
      },
      {
        path: "multi-step-modal",
        name: "Template Multi-Step Modal",
        component: MultiStepModal,
      },
    ],
  },
  {
    path: "/business/:id",
    name: "Business Profile",
    component: Business,
    beforeEnter: [authenticated, verified, authorizeBusinessAccess, hasActiveSubscription],
  },
  {
    path: "/business",
    name: "Business Dashboard",
    component: Business,
    beforeEnter: [authenticated, verified, onboarded, isOwner, hasActiveSubscription],
  },
  {
    path: "/business/funding-passport/loan-information",
    name: "Loan Information",
    component: Business,
    beforeEnter: [authenticated, verified, onboarded, isOwner, hasActiveSubscription],
  },
    {
    path: "/business/funding-passport/personal-credit-score",
    name: "Personal Credit Score",
    component: Business,
    beforeEnter: [authenticated, verified, onboarded, isOwner, hasActiveSubscription],
  },
  {
    path: "/business/financials",
    name: "Business Financials",
    component: financials,
    beforeEnter: [authenticated, verified, isOwner, hasActiveSubscription],
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
    beforeEnter: [notAuthenticated],
  },
  {
    path: "/signup",
    name: "SignUp",
    component: SignUp,
    beforeEnter: [notAuthenticated],
  },
  {
    path: "/verify-email",
    name: "Verify Email",
    component: VerifyEmail,
    beforeEnter: [authenticated, notVerified],
  },
  {
    path: "/expired-verification",
    name: "Expired Verification Link",
    component: ExpiredVerificationLink,
    beforeEnter: [authenticated, oobCode],
  },
  {
    path: "/choose-account",
    name: "Choose Account",
    component: ChooseAccount,
    beforeEnter: [authenticated, verified, notOnboarded],
  },
  {
    path: "/access-code",
    name: "Access Code",
    component: AccessCode,
    beforeEnter: [authenticated, verified, notAccessCode],
  },
  {
    path: "/search-results",
    name: "Search Results",
    component: SearchResults,
    beforeEnter: [authenticated, verified, isRepresentative],
  },
  {
    path: "/kyc/personal-details",
    name: "Personal Details",
    component: RepresentativePersonalDetails,
    beforeEnter: [authenticated, verified, notOnboarded, hasAccessCode],
  },
  {
    path: "/kyc/personal-contact",
    name: "Personal Contact",
    component: RepresentativePersonalContact,
    beforeEnter: [authenticated, verified, notOnboarded, hasAccessCode],
  },
  // BSBLD-971: Temporarily removed from SMB onboarding — will be re-enabled in a future release
  // {
  //   path: "/kyc/verify-identity",
  //   name: "Verify Identity",
  //   component: RepresentativeVerifyIdentity,
  //   beforeEnter: [authenticated, verified, notOnboarded, hasAccessCode],
  // },
  //  {
  //   path: "/kyc/demographic",
  //   name: "Demographic",
  //   component: RepresentativeDemographic,
  //   beforeEnter: [authenticated, verified, notOnboarded, hasAccessCode],
  // },
  {
    path: "/kyb/claim-business",
    name: "Claim Business",
    component: ClaimBusinessScreen,
    beforeEnter: [authenticated, verified, notOnboarded],
  },
  {
    path: "/kyb/entity-details",
    name: "Entity Details",
    component: EntityDetails,
    beforeEnter: [authenticated, verified, notOnboarded],
  },
  {
    path: "/kyb/verify-ownership",
    name: "Verify Ownership screen",
    component: VerifyOwnership,
    beforeEnter: [authenticated, verified, notOnboarded],
  },
  {
    path: "/kyb/web-and-socials",
    name: "Web And Socials",
    component: WebAndSocials,
    beforeEnter: [authenticated, verified, notOnboarded],
  },
  {
    path: "/kyb/payment",
    name: "Payment",
    component: Payment,
    beforeEnter: [authenticated, verified, notOnboarded],
  },
  {
    path: "/representative",
    name: "Representative Dashboard",
    component: Representative,
    beforeEnter: [authenticated, verified, onboarded, isRepresentative],
  },
  {
    path: "/settings",
    name: "Settings",
    component: Settings,
    beforeEnter: [authenticated, verified, onboarded],
  },
  {
    path: "/settings/billing/manage-subscription",
    name: "Settings Billing Manage Subscription",
    component: ManageSubscription,
    beforeEnter: [authenticated, verified, onboarded, notActiveSubscription],
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;